import { useIsPodcastBlockedFromTldl } from 'api/hooks/useGetPodcastConfig';
import { SearchEpisode } from 'components/SearchModal';
import { useCallback, useEffect, useRef, useState } from 'react';

type TldlEpiosdeValidationReason = 'blocked';

type OnSuccess = (episode: SearchEpisode) => void;

type OnFailure = (
  episode: SearchEpisode,
  reason: TldlEpiosdeValidationReason,
) => void;

type ValidateEpisodeConfig = {
  onSuccess?: OnSuccess;
  onFailure?: OnFailure;
};

type ValidateEpisode = (
  episode: SearchEpisode,
  config?: ValidateEpisodeConfig,
) => void;

type State = ValidateEpisodeConfig & {
  episode: SearchEpisode;
};

export default function useValidateTldlEpisode() {
  const [state, setState] = useState<State>();
  const { data: isBlocked } = useIsPodcastBlockedFromTldl(
    state?.episode.podcast.id,
  );

  const prevIsBlocked = useRef<boolean>();

  const validateEpisode: ValidateEpisode = useCallback(
    (episode, config) => {
      if (state === undefined) {
        setState({ episode, ...config });
      }
    },
    [state],
  );

  useEffect(() => {
    if (
      state?.episode &&
      isBlocked !== undefined &&
      prevIsBlocked.current !== isBlocked
    ) {
      if (isBlocked) {
        state?.onFailure?.(state?.episode, 'blocked');
      } else {
        state?.onSuccess?.(state?.episode);
      }
      setState(undefined);
      prevIsBlocked.current = undefined;
    }
  }, [isBlocked, state]);

  useEffect(() => {
    prevIsBlocked.current = isBlocked;
  }, [isBlocked]);

  return { validateEpisode };
}
